import React from 'react'
import PropTypes from 'prop-types'
import styles from './Card.scss'
import { classNames } from './../../../utils/styles'

const Card = ({ children, onClick, error }) => {
  return (
    <div className={classNames(styles.Button, error && styles.Error)} onClick={onClick}>
      {children}
    </div>
  )
}

export default Card

Card.propTypes = {
  children: PropTypes.any,
  error: PropTypes.any,
  onClick: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Form/Card/CardButton.js